import { render } from "./JoinSeason.vue?vue&type=template&id=1f5c019c&scoped=true"
import script from "./JoinSeason.vue?vue&type=script&lang=js"
export * from "./JoinSeason.vue?vue&type=script&lang=js"

import "./JoinSeason.vue?vue&type=style&index=0&id=1f5c019c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5c019c"]])

export default __exports__